import { IPage } from '../auth/RouteAuthWrapper'

export function findRouteByUrl(routes: Partial<IPage>[], targetUrl: string): Partial<IPage> | undefined {
  for (const route of routes) {
    if (route.to === targetUrl) {
      return route
    }
    if (route.pages) {
      const found = findRouteByUrl(route.pages, targetUrl)
      if (found) {
        return found
      }
    }
  }
  return undefined
}
